import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";
import {useParams} from "react-router-dom";
import ImageGallery from "react-image-gallery";

export default () => {
    let title = "Гостиницы, мотели, кемпинги Hotels, Motels, Campings";

    const itemsData = [
        {
            id: 1,
            location: 'Брест',
            name: 'База областного центра детско-юношеского туризма и экскурсий',
            phones: [
                'приемная: (+375) 162 23-83-50',
                'отдел туризма: (+375) 162 21-12-32',
            ],
            countItem: '165 номеров',
        },
        {
            id: 2,
            location: 'Брест',
            name: 'Гостиница «БЕЛАРУСЬ»',
            adress: '224030 г. Брест, бульвар Шевченко, 6',
            phones: [
                '(+375) 162 22-16-48',
                '(+375) 162 22-16-46',
            ],
            url: 'www.brestturist.by',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/bel550.jpg'),
                    alt: 'Гостиница «БЕЛАРУСЬ»',
                }
            ],
            imgs: [
                require('./../img/ReferenceInformation/Hotels/shewchenko.jpg'),
            ],
            desc: [
                'Бюро путешествий и экскурсий, оплата по кредитный карточкам, конференц-зал, ресторан, бар, парикмахерская, продажа сувениров, массажный кабинет, компьютерный зал, казино, зал игровых автоматов, камеры хранения, пункт обмена валюты, магазин, охраняемая автостоянка, камера хранения, сауна, солярий.',
                'Гостиница (архитектор 3. Левченко) построена в 1971 году у западного въезда в город. Была спроектирована на 532 места. Здание 9-этажное, прямоугольное в плане, с встроенными в 1-й этаж рестораном «Беларусь» (180 мест, банкетный зал на 40 мест), парикмахерский салон, телефонами-автоматами междугородней связи, кафе, баром. Архитектура здания лаконична, увязана с окружающей застройкой. Фасады облицованы керамической неглазурованной плиткой песочного цвета, межоконные простенки - чёрной глазурованной. Рядом с гостиницей автостоянка для туристских автобусов и легкового транспорта.',
                'Расстояние от: железно-дорожной станции Брест-Центральный - 2,5км, автостанции - 2,5 км.',
            ],
            countItem: '165 номеров',
        },
        {
            id: 3,
            location: 'Брест',
            name: 'Гостиница «БУГ»',
            adress: '224005 г. Брест, ул. Ленина, 2',
            phones: [
                '(+375) 162 23-61-70',
                '(+375) 162 23-73-73',
                'факс: (+375) 162 22-24-72',
            ],
            url: 'http://www.brestturist.by',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/bug550.jpg'),
                    alt: 'Гостиница «БУГ»',
                }
            ],
            desc: [
                'Ресторан, бар, сауна, солярий, банкомат.',
                'Расположена при въезде в город со стороны Привокзальной площади. ',
                'Построена в 1958 из кирпича по проекту архитектора Г. Бенедиктова. 4-этажное в центре с 3-этажными пристройками. Г-образное в плане здание. Закруглённой угловой частью выходит на площадь - транспортную развязку при въезде на железнодорожный мост.',
                'На 1-м этаже - парадный вестибюль круглой формы с 6 колоннами по кругу, в котором размещены гостиничные службы. Из вестибюля широкая лестница ведёт на этажи.',
                'Архитектурный облик здания сдержанный, использованы элементы классической ордерной архитектуры. 3 верхних этажа центральной закруглённой части украшены пилястрами коринфского ордера. ',
                'Здание характерно для советской архитектуры 1950-х г. В здании гостиницы находится ресторан «Буг».',
                'Типы номеров: стандартные одноместные, двухместные, трехместные, четырехместные номера и 1 люкс.',
            ],
            countItem: '80 номеров',
        },
        {
            id: 4,
            location: 'Брест',
            name: 'Гостиница «ВЕСТА»',
            adress: '224005 г. Брест, ул. Крупской, 16',
            phones: [
                '(+375) 162 23-71-69',
                '(+375) 162 23-78-33',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/wst550.jpg'),
                    alt: 'Гостиница «ВЕСТА»',
                }
            ],
            desc: [
                'Обслуживание в номерах, оплата по кредитным карточкам, конференц-зал, бар, кафе, парикмахерская, массажный кабинет, сауна, солярий, оборудование для инвалидов, VIP номера, Интернет, дискотека.',
                'Типы номеров: люксы, стандартные одноместные, двухместные и трехместные номера.',
                'Расстояние от: железно-дорожной станции Брест-Центральный - 1 км, автостанции - 1 км.',
            ],
            countItem: '59 номеров',
        },
        {
            id: 5,
            location: 'Брест',
            name: 'ОАО Гостиница «Дружба» СП «ВЕСТАВТО»',
            adress: '224029 г. Брест, д. Старые Задворцы',
            phones: [
                '(+375) 162 97-00-42',
                'факс: (+375) 162 97-01-82',
            ],
            url: 'http://www.druzbahotel.by/',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/druzba.jpg'),
                    alt: 'Гостиница «Дружба»',
                }
            ],
            desc: [
                'Услуги: ресторан, кафе, бар, пункт обмена валют, конференц-зал, охраняемая стоянка, камера хранения, продажа сувениров, бильярд, VIP номера',
            ],
            countItem: '154 номера',
        },
        {
            id: 6,
            location: 'Брест',
            name: 'Гостиница «Брест-Интурист»',
            adress: '224030 г. Брест, пр. Машерова, 15',
            phones: [
                '(+375) 162 22-18-86',
                '(+375) 162 20-20-83',
                '(+375) 162 22-19-00',
                'турбюро: (+375) 162 20-20-38',
                'факс: (+375) 162 22-19-00',
            ],
            url: 'http://www.brestintourist.com/',
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/int550.jpg'),
                    alt: 'Гостиница «Брест-Интурист»',
                }
            ],
            imgs: [
                require('./../img/ReferenceInformation/Hotels/intur_p1.jpg'),
            ],
            desc: [
                'Услуги: обслуживание в номерах, бюро путешествий и экскурсий, ресторан, казино, бар, кафе, оплата по кредитным карточкам, Интернет, конференц-зал, услуги почты, круглосуточный обменный пункт, охраняемая автостоянка, парикмахерская, массажный кабинет, кабинет квантовой терапии, продажа сувениров, служба безопасности, трансфер, апартаменты, химчистка, прачечная, камера хранения, салон красоты, массаж, медпункт, солярий.',
                'Гостиница входит в ансамбль общественных и торгово-бытовых зданий на Московской улице. Построена в 1975 году по проекту архитекторов Г. Бенедиктова, В. Астаповича и Е. Лукомской. Пространственный эффект достигается контрастным сочетанием 11-этажного корпуса-пластины и вытянутого по горизонтали 2-этажного встроенно-пристроенного здания ресторана «Интурист». Здание гостиницы возведено из железобетонных панелей.',
                'Выразительность фасадов достигается использованием пилонов и горизонтальных простенков между этажами, облицованных белой глазурованной плиткой. Вход оформлен чёрным лабрадоритом и белым мрамором. На 1-м этаже просторный вестибюль с киосками, служебными и вспомогательными помещениями.',
                'Планировка жилых этажей коридорная, с холлами и лифтовыми площадками.',
                'Комфортабельные номера рассчитаны на 1 - 2 человек. Сдвинутый вглубь корпус ресторана позволил благоустроить прилегающую территории и организовать стоянку автотранспорта. Перед зданием фонтан с многофигурной скульптурной композицией из меди.',
                'Типы номеров: двухместный 3-комнатный номер высшей категории (апартамент), двухместный 2-комнатный номер высшей категории (полулюкс), двухместный 2-комнатный номер высшей категории (люкс), четырехместный номер 2-комнатный 1-й категории, одноместный номер 1-комнатный 1-й категории (повышенной комфортности), двухместный номер 1-комнатный (стандарт), одноместный номер 1-комнатный (стандарт), двухместный номер (эконом-класс), одноместный номер (эконом-класс).',
            ],
            countItem: '140 номеров',
        },
        {
            id: 7,
            location: 'Брест',
            name: 'Гостиница «МОЛОДЕЖНАЯ»',
            adress: '224000, г. Брест, Комсомольская, 6',
            phones: [
                '(+375) 162 21-63-76',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/mol550.jpg'),
                    alt: 'Гостиница «МОЛОДЕЖНАЯ»',
                }
            ],
        },
        {
            id: 8,
            location: 'Брест',
            name: 'Гостиница «СТРОИТЕЛЬ»',
            adress: '224028, г. Брест, Ленинградская, 2',
            phones: [
                '(+375) 162 41-94-68',
                '(+375) 162 41-49-95',
            ],
        },
        {
            id: 9,
            location: 'Брест',
            name: 'Гостиница «ЮНОСТЬ»',
            adress: '224032, г. Брест, Советской конституции, 14',
            phones: [
                '(+375) 162 41-50-68',
            ],
        },
        {
            id: 10,
            location: 'Брест',
            name: 'Гостиница «5 колец»',
            adress: '224030 г. Брест ул. Гоголя, 9',
            phones: [
                '(+375) 162 20-84-95',
                '(+375) 162 20-85-58',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/pjat.jpg'),
                    alt: 'Гостиница «5 колец»',
                }
            ],
            desc: [
                'Гостиница находится в центре Бреста, вблизи «Брестской Крепости», парка «Культуры и отдыха». Гостиница удалена от шумовых магистралей г. Бреста. Расстояние от: железно - дорожной станции Брест - Центральный - 1км, автостанции – 1 км.',
                'Гостиница «5 колей» предлагает Вам уютные, чистые номера различных категорий и по приемлемым ценам, что выгодно отличает нас от других гостиниц нашего города.',
                'К Вашим услугам: одноместные однокомнатные, двухместные однокомнатные, двухместные двухкомнатные номера.',
            ],
        },
        {
            id: 11,
            location: 'Барановичи',
            name: 'Гостиница «ГОРИЗОНТ»',
            adress: '225320 г. Барановичи, ул. Советская, 82',
            phones: [
                '(+375) 163 42-32-36',
                '(+375) 163 42-10-12',
                'факс: (+375) 163 42-12-54',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/gor550.jpg'),
                    alt: 'Гостиница «ГОРИЗОНТ»',
                }
            ],
            desc: [
                'Барановичская гостиница «Горизонт» — это 9-этажное здание, расположенное на центральной площади города по соседству с краеведческим музеем, кинотеатром, парком культуры, теннисным кортом и типографией. Гостиничный фонд состоит из 116 номеров (17 номеров бизнесс-класса, 48 стандарт-класса, остальные — эконом-класса). Все номера оборудованы спутниковым телевидением, душевыми кабинами или ваннами, туалетами. Часть оснащена холодильниками, мини-барами, телефонами с выходом на междугородную и международную связь.',
            ],
            countItem: '116 номеров на 167 мест',
        },
        {
            id: 12,
            location: 'Барановичи',
            name: 'Гостиница «КОМСОМОЛЬСКАЯ»',
            adress: '225320 г. Барановичи, ул. Гагарина, 29',
            phones: [
                '(+375) 163 42-45-93',
                '(+375) 163 42-48-29',
                '(+375) 163 42-24-68',
            ],
        },
        {
            id: 13,
            location: 'Береза',
            name: 'Гостиница «ЯСЕЛЬДА»',
            adress: '225210, Береза, Ленина, 58',
            phones: [
                '(+375) 1643  2-23-67',
            ],
        },
        {
            id: 14,
            location: 'Иваново',
            name: 'Гостиница «ПОД ЛИПАМИ»',
            adress: '225800 Ивановский район, г. Иваново, трасса Брест-Гомель',
            phones: [
                '(+375) 1652  2-31-68',
            ],
        },
        {
            id: 15,
            location: 'Ивацевичи',
            name: 'Гостиница «ЩАРА»',
            adress: '225250 г. Ивацевичи, ул. Комсомольская, 23',
            phones: [
                '(+375) 1645  2-13-67',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/scara550.jpg'),
                    alt: 'Гостиница «ЩАРА»',
                }
            ],
            desc: [
                'Номера: люкс, полу-люкс.',
            ],
        },
        {
            id: 16,
            location: 'Каменецкий район',
            name: 'Гостиница «БЕЛОВЕЖСКАЯ ПУЩА»',
            adress: '225050 Каменецкий район, д. Каменюки',
            phones: [
                '(+375) 1631 5-65-43',
                '(+375) 1631 5-64-97',
                'гостиница №1: (+375) 1631 5-64-98',
                'гостиница №2: (+375) 1631 5-65-72',
                'гостиница №3: (+375) 1631 5-65-43',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/pus550.jpg'),
                    alt: 'Гостиница «БЕЛОВЕЖСКАЯ ПУЩА»',
                }
            ],
            desc: [
                'На территории национального парка имеются 3 гостиницы (3 корпуса комплекса "Каменюки") на 176 мест, спорткомплекс, сауны, 3 гостевых домика, ресторан, где можно отведать национальные блюда, приготовленные из мяса дичи. Рядом с гостиницей находится художественная мастерская по изготовлению сувениров. В административном корпусе парка есть зал для симпозиумов, конференций и других мероприятий.',
            ],
            countItem: '176 мест',
        },
        {
            id: 17,
            location: 'Кобрин',
            name: 'Гостиница «Беларусь»',
            adress: '225306, г. Кобрин, ул. Суворова, 29',
            phones: [
                'администратор: (+375) 1642 2-25-57',
                'администратор: (+375) 1642 2-13-67',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/kobbel.jpg'),
                    alt: 'Гостиница «Беларусь»',
                }
            ],
        },
        {
            id: 18,
            location: 'Кобрин',
            name: 'Гостиница «СУВОРОВ»',
            adress: '225860 г. Кобрин, ул. Дружбы, 2',
            phones: [
                '(+375) 1642 3-90-97',
                'факс: (+375) 1642 3-90-96',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/suwg.jpg'),
                    alt: 'Гостиница «СУВОРОВ»',
                }
            ],
        },
        {
            id: 19,
            location: 'Кобринский район',
            name: 'Гостиница СП «Кобвар»',
            adress: 'Кобринский район, д. Петьки',
            phones: [
                '(+375) 1642 7-62-10',
            ],
        },
        {
            id: 20,
            location: 'Пинск',
            name: 'Гостиница «ПРИПЯТЬ»',
            adress: '225710 г. Пинск, ул. Днепровской флотилии, 35',
            phones: [
                '(+375) 165 35-96-33',
                '(+375) 165 35-96-33',
                '(+375) 165 35-96-32',
                '(+375) 165 35-97-66',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/pri550.jpg'),
                    alt: 'Гостиница «ПРИПЯТЬ»',
                }
            ],
            desc: [
                'Гостиничный комплекс «Припять» имеет разнообразную структуру для обслуживания клиента, в ее состав входит: 3 здания гостиниц на 395 мест, ресторан на 100 мест, банкетный зал - 50 мест, банкетные залы на 12 и 4 посадочных места, кафе «Бригантина» - 32 места, кафе «Бриз» - 32 места, кафе «Причал» - 20 мест, кафе «Парус» - 16 мест, буфеты в горисполкоме и спецатобазе, коммерческий магазин, торговый киоск, лоток на рынке.',
            ],
        },
        {
            id: 21,
            location: 'Пружаны',
            name: 'Гостиница «МУХАВЕЦ»',
            adress: '225140, Пружаны, улица Р. Ширмы, 15',
            phones: [
                '(+375) 1632 7-14-60',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/muh550.jpg'),
                    alt: 'Гостиница «МУХАВЕЦ»',
                }
            ],
        },
        {
            id: 22,
            location: 'Пружаны',
            name: 'Гостиница «Верас»',
            adress: '225140, Пружаны, улица Горина Коляды, 24',
            phones: [
                '(+375) 1632 71-3-11',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/veras.png'),
                    alt: 'Гостиница «Верас»',
                },
            ],
        },
        {
            id: 23,
            location: 'Столин',
            name: 'Гостиница «ГОРЫНЬ»',
            adress: '225510 г. Столин, ул. Ленина, 5',
            phones: [
                '(+375) 1655 2-14-44',
                '(+375) 1655 2-13-67',
            ],
            gal: [
                {
                    src: require('./../img/ReferenceInformation/Hotels/hotel-goryn-stolin-facade-5618.jpg'),
                    alt: 'Гостиница «ГОРЫНЬ»',
                },
                {
                    src: require('./../img/ReferenceInformation/Hotels/hotel-goryn-stolin-5620.jpg'),
                    alt: 'Гостиница «ГОРЫНЬ»',
                },
                {
                    src: require('./../img/ReferenceInformation/Hotels/hotel-goryn-stolin-5621.jpg'),
                    alt: 'Гостиница «ГОРЫНЬ»',
                },
                {
                    src: require('./../img/ReferenceInformation/Hotels/hotel-goryn-stolin-5619.jpg'),
                    alt: 'Гостиница «ГОРЫНЬ»',
                },
                {
                    src: require('./../img/ReferenceInformation/Hotels/hotel-goryn-stolin-5622.jpg'),
                    alt: 'Гостиница «ГОРЫНЬ»',
                },
            ],
            desc: [
                'Гостиница расположена в центральной части г. Столина, вблизи основных достопримечательностей. Открыта в 1988 году, реконструирована в 2007. Пятиэтажное здание. Номерной фонд гостиницы состоит из 44 номеров. Типы номеров: номера класса люкс, номера класса полулюкс, стандартные номера. В гостинице есть номера для людей с ограниченными возможностями. ',
            ],
        },
    ];

    let get_all_list = (data) => {
        return (
            <ul>
                {data?.map((h) => {
                    const link = "/reference-information-hotels/"+h.id;
                    return(<li><a href={link}>{h.location}. {h.name}</a></li>)
                })}

            </ul>
        );
    }

    let get_item = (data) => {
        let result = null;

        if (data.name != undefined) {
            title = data.name;
        }

        let gal = [];
        if (data.gal != undefined) {
            data.gal.map(item => {
                gal.push({
                    original: item.src,
                    thumbnail: item.src,
                    description: item.alt,
                });
            });
        }

        return (
            <>
                {data.adress != undefined && <p>{data.adress}</p>}
                {data.countItem != undefined && <p>{data.countItem}</p>}
                {data.phones != undefined && <ul>{data.phones.map(p => <li>{p}</li>)}</ul>}
                {data.url != undefined && <a href={data.url}>{data.url}</a>}
                {gal?.length > 0 &&
                    <div className="two-col-cell">
                        <ImageGallery
                            items={gal}
                            showIndex={false}
                            showBullets={true}
                            infinite={true}
                            showThumbnails={true}
                            showFullscreenButton={false}
                            showGalleryFullscreenButton={false}
                            showPlayButton={false}
                            showGalleryPlayButton={false}
                            showNav={true}
                            isRTL={false}
                            slideDuration={300}
                            slideInterval={2000}
                            slideOnThumbnailOver={false}
                            thumbnailPosition={'right'}
                            useWindowKeyDown={true}
                        />
                    </div>
                }
                {data?.desc?.length > 0 &&
                    data.desc.map(d => <p>{d}</p>)
                }
                {data?.imgs?.length > 0 &&
                    data.imgs.map(i => <img src={i}/>)
                }
            </>
        );
    }

    const params = useParams();

    let view = undefined;
    let nav = get_all_list(itemsData);
    if (params.id != undefined) {
        const id = itemsData.findIndex(e => e.id == params.id);
        if (id == -1) {
            view = get_all_list(itemsData);
        } else {
            view = get_item(itemsData[id]);
        }
    }

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    {view}
                </div>
                <div className="pageitem">
                    <hr/>
                    {nav}
                </div>
            </div>
        </>
    );
}